import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../auth';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { toast } from 'sonner';
import { MessageSquare, Send, CheckCircle2, XCircle } from 'lucide-react';

export default function SMSPage() {
  const [s, setS] = useState(null);
  const [to, setTo] = useState('');
  const [text, setText] = useState('[CRAFTFOOD] Тест отправки SMS через Solapi. craftfood.kr');
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
    axios.get(`${API}/settings/public`).then(r => setS(r.data)).catch(() => {});
  }, []);

  const isUnicode = /[^\x00-\x7F]/.test(text);
  const limit = isUnicode ? 70 : 160;
  const segments = text.length <= limit ? 1 : Math.ceil(text.length / (isUnicode ? 67 : 153));
  const msgType = segments === 1 ? 'SMS' : 'LMS';
  const estCost = segments * (msgType === 'SMS' ? 20 : 50); // approximate ₩

  const send = async () => {
    if (!to || !text) return;
    setSending(true);
    setResult(null);
    try {
      const res = await axios.post(`${API}/sms/test`, { to_phone: to, message: text });
      setResult({ ok: true, data: res.data });
      toast.success('SMS отправлен');
    } catch (e) {
      setResult({ ok: false, error: e.response?.data?.detail || e.message });
      toast.error('Не удалось отправить');
    } finally { setSending(false); }
  };

  return (
    <div className="space-y-6 max-w-3xl" data-testid="sms-page">
      <div>
        <p className="eyebrow mb-3">Уведомления</p>
        <h1 className="h-display text-4xl md:text-5xl">SMS <span className="text-[#C9A352]">через Solapi</span></h1>
        <p className="text-[#1A1A1A]/55 mt-2">Тестовая отправка SMS / LMS на корейский номер.</p>
      </div>

      <Card className="p-6 bg-[#F2EFE6]/30 border-[#556B2F]/30">
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <p className="eyebrow mb-1">Статус подключения</p>
            <p className="font-bold flex items-center gap-2">
              {s?.has_solapi_secret ? (
                <><CheckCircle2 className="h-4 w-4 text-[#556B2F]" /> Активно</>
              ) : (
                <><XCircle className="h-4 w-4 text-[#8E2A4E]" /> Не настроено</>
              )}
            </p>
          </div>
          <div>
            <p className="eyebrow mb-1">Sender</p>
            <p className="font-mono font-bold">{s?.solapi_sender || '—'}</p>
          </div>
        </div>
      </Card>

      <Card className="p-6 md:p-8 space-y-5">
        <div>
          <Label className="text-sm font-semibold">Получатель (010-номер)</Label>
          <Input
            value={to}
            onChange={(e) => setTo(e.target.value)}
            placeholder="01012345678 или 010-1234-5678"
            className="mt-2 h-11 border-[#1A1A1A]/15 focus:ring-[#556B2F]"
            data-testid="sms-to"
          />
        </div>
        <div>
          <Label className="text-sm font-semibold">Текст сообщения</Label>
          <Textarea
            rows={5}
            value={text}
            onChange={(e) => setText(e.target.value)}
            className="mt-2 border-[#1A1A1A]/15 focus:ring-[#556B2F]"
            data-testid="sms-text"
          />
          <div className="flex justify-between text-xs text-[#1A1A1A]/55 mt-2">
            <span>{text.length} символов · {isUnicode ? 'Unicode' : 'ASCII'} · {msgType} ({segments} сегмент{segments>1?'ов':''})</span>
            <span className="font-mono">≈ {estCost} ₩</span>
          </div>
        </div>
        <Button onClick={send} disabled={sending || !s?.has_solapi_secret} className="cff-button-primary h-11" data-testid="sms-send">
          <Send className="h-4 w-4 mr-2" /> {sending ? 'Отправка…' : 'Отправить тест'}
        </Button>
      </Card>

      {result && (
        <Card className={`p-6 ${result.ok ? 'bg-[#F2EFE6]/40 border-[#556B2F]/40' : 'bg-[#F6E9E5]/40 border-[#8E2A4E]/40'}`} data-testid="sms-result">
          <p className="eyebrow mb-2">{result.ok ? 'Успех' : 'Ошибка'}</p>
          <pre className="text-xs overflow-x-auto font-mono">{JSON.stringify(result.ok ? result.data : result.error, null, 2)}</pre>
        </Card>
      )}
    </div>
  );
}
